module.exports = __webpack_public_path__ + "img/Group 427325155.971b3ff4.svg";